import { EventEmitter } from 'modules/event-emitter';
import { ResultCreate } from 'components/dialog-task';

interface Events {
  'task-created': ResultCreate;
}
export const emitterLayoutContent = new EventEmitter<Events>();
